/*
  panthure.js — tiny, dependency-free motion + interaction helpers for the
  Bobbel custom sections. Loaded with `defer`. Respects prefers-reduced-motion.
*/
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal-on-scroll (.ab-reveal -> .ab-revealed) ------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.ab-reveal:not(.ab-revealed)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ab-revealed'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-ab-delay') || '0', 10);
            setTimeout(function () { el.classList.add('ab-revealed'); }, delay);
            obs.unobserve(el);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Count-up for stat numbers ([data-ab-countup]) ------------------- */
  function initCountUp() {
    var els = document.querySelectorAll('[data-ab-countup]');
    if (!els.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-ab-countup'));
      if (isNaN(target)) return;
      if (reduceMotion) { el.textContent = target; return; }
      var dur = 1200;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { run(entry.target); obs.unobserve(entry.target); }
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hero in-frame mobile nav toggle --------------------------------- */
  function initNavToggle() {
    document.querySelectorAll('[data-ab-nav-toggle]').forEach(function (btn) {
      var targetId = btn.getAttribute('data-ab-nav-toggle');
      var menu = document.getElementById(targetId);
      if (!menu) return;
      btn.addEventListener('click', function () {
        var open = menu.classList.toggle('ab-nav__menu--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('ab-nav-open', open);
      });
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          menu.classList.remove('ab-nav__menu--open');
          btn.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('ab-nav-open');
        });
      });
    });
  }

  function init() {
    initReveal();
    initCountUp();
    initNavToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init within the Shopify theme editor when sections reload.
  document.addEventListener('shopify:section:load', init);
})();
